module.exports = {"451381100":"岭南镇","451381101":"北泗镇","451381102":"河里镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/451381.json
// module id = 2304
// module chunks = 0